import { useEffect } from "react";
import ApplicationContainer from "components/application-container/ApplicationContainer";
import AuthenticationFailedCard from "components/card/authenticate-failed/AuthenticationFailed";
import { GA_DEDUP_KEYS, GA_EVENT_CONFIGS } from "constants/gaEvents";
import { pushGTMEventOnce } from "utils/gaEventDedup";

const AuthenticationFailedPage = () => {
    useEffect(() => {
        pushGTMEventOnce(GA_DEDUP_KEYS.VIEW_AUTH_FAILED_PAGE, GA_EVENT_CONFIGS.SAVE_CONTINUE_AUTH_FAILED_PAGE_VIEWED);
    }, []);

    return (
        <>
            <title>Authentication Failed | AAA Life</title>
            <ApplicationContainer data-testid="authentication-failed-page">
                <AuthenticationFailedCard />
            </ApplicationContainer>
        </>
    );
};

export { AuthenticationFailedPage };
export default AuthenticationFailedPage;
